module.exports = __webpack_public_path__ + "images/f80d3f15b68d761dd27c5fc6fa293a13-illu_clapper.svg";